/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { rootStoreReducer } from './root-store.reducer';
import { rootKey } from './root-store.selectors';

import { ControllerInitialDataStoreModule } from
    './controller-initial-data-store/controller-initial-data-store.module';

import { ControllerSiteStoreModule } from './controller-site-store/controller-site-store.module';
import { AviDataGridStoreModule } from './avi-data-grid-store/avi-data-grid-store.module';
import { IInfraCloudStateModule } from './infra-cloud-store/infra-cloud-store.module';
import { UserAccountModule } from './user-account/user-account.module';
import { UserPreferencesModule } from './user-preferences/user-preferences.module';
import { SystemInfoModule } from './system-info/system-info.module';
import { UserProfileModule } from './user-profile/user-profile.module';
import { AppInsightsStoreModule } from './app-insights-store/app-insights-store.module';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forRoot({ [rootKey]: rootStoreReducer }),
        ControllerInitialDataStoreModule,
        IInfraCloudStateModule,
        ControllerSiteStoreModule,
        AviDataGridStoreModule,
        UserAccountModule,
        UserPreferencesModule,
        SystemInfoModule,
        UserProfileModule,
        AppInsightsStoreModule,
    ],
})
export class RootStoreModule {}
